import { FIXABLE_BLOCK_HANDLERS } from 'govbr.frontend.policy/helpers/fixableBlocks';

/**
 * Aplica handlers de correção configurados aos blocos de conteúdo Plone e retorna
 * apenas o objeto `blocks` corrigido.
 *
 * @param {Object} [content={}] - Objeto de conteúdo Plone (pode conter UID e blocos)
 * @param {Object} [content.blocks={}] - Mapa de IDs de blocos para objetos de bloco
 * @returns {Object} Objeto `blocks` com as correções aplicadas
 */
export const applyBlockFixes = (content = {}) => {
  const blocks = content.blocks ?? {};

  // Aplica handlers de correção a todos os blocos (não remove blocos)
  const fixedBlocks = Object.fromEntries(
    Object.entries(blocks).map(([blockId, block]) => {
      try {
        const blockType = block?.['@type'];
        const fixHandler = FIXABLE_BLOCK_HANDLERS[blockType];

        if (typeof fixHandler === 'function') {
          return [blockId, fixHandler(block, content)];
        }

        return [blockId, block];
      } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(
          `Falha no handler de bloco para tipo "${block?.['@type'] || 'desconhecido'}" (ID: ${blockId})`,
          error,
        );
        return [blockId, block];
      }
    }),
  );

  return fixedBlocks;
};
